import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Button } from 'antd-mobile';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import AwsS3 from '@uppy/aws-s3';
import AWS from 'aws-sdk';
import AwsS3Multipart from '@uppy/aws-s3-multipart';
import Webcam from '@uppy/webcam';
import Url from '@uppy/url';
import { DragDrop, Dashboard, DashboardModal, UppyContainer, StatusBar } from '@uppy/react';
import { getLocalQueryString } from '../../../utils/common';
import Chinese from './zh'; //'@uppy/locales/lib/zh_CN';
import { getUploadToken } from './action';
import '@uppy/core/dist/style.css';
import '@uppy/status-bar/dist/style.css';
import '@uppy/drag-drop/dist/style.css';
import '@uppy/progress-bar/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/webcam/dist/style.css';
import '@uppy/url/dist/style.css';
import './index.scss';
// const GoogleDrive = require('@uppy/google-drive');
// const Dropbox = require('@uppy/dropbox');
// const Instagram = require('@uppy/instagram');
// const Webcam = require('@uppy/webcam');
let globalAwss3Token = {};
let uppy = Uppy({
	// meta: { type: 'avatar' },
	restrictions: {
		// maxFileSize: 1000000,
		maxNumberOfFiles: 9,
		minNumberOfFiles: 1,
		allowedFileTypes: ['image/*', 'video/*']
	},
	autoProceed: false, //cache file , 点击开始上传 ( true )， 或者等会上传( false )
	debug: false,
	locale: Chinese,
	setFileMeta: (fileID, data) => {
		console.log('setFileMeta', fileID, data);
	},
	onBeforeFileAdded: (currentFile, files) => {
		// console.log( "file...." ,files);
		const modifiedFile = Object.assign({}, currentFile, {
			lastname: currentFile.name + Date.now()
		});
		// console.log ( "modifiedFile" , currentFile ,modifiedFile);
		if (!currentFile.type) {
			//==='image/png'
			// log to console
			uppy.log(`Skipping file because it has no type`);
			// show error message to the user
			uppy.info(`该文件类型不支持`, 'error', 5000);
			return false;
		}
		return modifiedFile;
	},
	onBeforeUpload: files => {
		console.log(files);
		const updatedFiles = {};
		Object.keys(files).forEach(fileID => {
			console.log('uploadid', fileID, 'key', files[fileID].name);
			updatedFiles[fileID] = {
				...files[fileID],
				name: 'www' + new Date().getTime() + '__' + files[fileID].name
			};
		});
		console.log('updatedFiles', updatedFiles);
		return updatedFiles;
	}
});
// uppy.use(Tus, {
// 	// endpoint: '/upload'
//     endpoint: 'https://master.tus.io/files/',
//     limit : 1,  //并发个数
//     chunkSize:1024*200
// });
// Create initial parameters JSON for putBucketCors
let localaws = null;
function fnAWS() {
	console.log(globalAwss3Token, 'globalAwss3Token fnAWS');
	if (!localaws) {
		AWS.config.update({
			region: globalAwss3Token.bucket,
			credentials: new AWS.CognitoIdentityCredentials({
				IdentityPoolId: 'www'
			})
		});
		localaws = new AWS.S3({
			// accessKeyId: "km9Oseo35LO3PrUIY6w",
			// secretAccessKey: "FK2R6C3MVBIAU849RP34CR7OAJ9P7GWQASD9EVC",
			// sessionToken: "poQcAC92JGUzThOcsjEJK8052GWLrp821/8jQoBjBB3D3Cx+5VwAw//X2S7K9UdzqR5UXE1aNnqd8CLpyzelBsrOc1wxvnWbO/fETTJavTBGFGG4DLap1/UrL9pyveyD2YMlEjxNgj5t4gPJaA9IglRX4TuKjJs1SUiGbtM/BSuv+JOjLkPU8KuawUdDUqgYae2gngGrCp2RFecpn58IZjcRvoi2dEbH1VaDJveFe2dKM8XwkZ8fU9bAyxB9q+Lw/F9Jr0yOOE528oSMXe22SC+z4Bbsq+W5YGhgtEPkq/uApg8hnigjYSg78i6qM+LlkLFJ055GKWNKynqQeiL3T9N8azSCPn1w2a9XCBa5PRrzmws45/gs9KuPjdFT6gf1edHQLMZK7mj4xykUkK3KQaQ56XIZBZiGa96lw/pYFbiSy08/vTgv7a/hMB66Ytu7k18Oi2m8sr9yZ0wZhRBSzwGczgY1oXhDj8/rZQeKHWBuFjiB2PI4xP95vOPUHBvvADueypr53PALiw+5YIXS7n+9+w932PRg1Ij+KOugtvI7BmuaCDLXWf2dq2zgWH88/7m63SjmPm45iLBJVFQ+kpjh/Wlvyr1kUWNB/Ssxv38=",
			// bucket: "copyrightupload",
			// endpoint: "s3-wxlf.vphotos.cn",
			// uploadPath: "app/vphoto/roleUpload/copyright/",
			// expiration: "2020-03-16 21:26:59",
			...globalAwss3Token,
			apiVersion: '2020-03-16',
			s3BucketEndpoint: true
		});
	}
	return localaws;
}

uppy.use(AwsS3Multipart, {
	limit: 3,
	timeout: 1000 * 60,
	chunkSize: 1024 * 20,
	// uploadURL:'',
	// companionUrl: 'https://companion.myapp.com/'
	// companionUrl: 'https://uppy-companion.myapp.net/',
	// companionUrl:'https://s3-wxlf.vphotos.cn/copyrightupload/app/vphoto/roleUpload/copyright/',
	listParts: function(file, { uploadId, key }) {
		console.log('list parts...', file, uploadId, key);
	},
	createMultipartUpload: function(file) {
		console.log('createMultipartUpload', file);
		return new Promise(resolve => {
			console.log('path1...', globalAwss3Token.bucket + '/' + globalAwss3Token.uploadPath + file.name);
			fnAWS().createMultipartUpload(
				{
					Bucket: globalAwss3Token.bucket, //"copyrightupload",
					Key: globalAwss3Token.bucket + '/' + globalAwss3Token.uploadPath + file.name //"copyrightupload/app/vphoto/roleUpload/copyright/" + file.name
				},
				(error, data) => {
					console.log('data', data);
					resolve({
						uploadId: data.UploadId,
						key: data.Key
					});
				}
			);
		});
	},
	prepareUploadPart: function(file, partData) {
		console.log('prepareUploadPart', file, partData);
		// return null;
		return new Promise(resolve => {
			console.log('path2...', globalAwss3Token.bucket + '/' + partData.key);
			fnAWS().getSignedUrl(
				'uploadPart',
				{
					//uploadPart
					Bucket: globalAwss3Token.bucket, //'copyrightupload',
					Key: globalAwss3Token.bucket + '/' + partData.key, //"copyrightupload/"+partData.key,
					UploadId: partData.uploadId,
					PartNumber: partData.number,
					Body: '', // Empty, because it is uploaded later
					Expires: 5 * 60
				},
				(err, url) => {
					let url2 = url.substring(0, url.indexOf('?')) + '?partNumber=' + partData.number + '&uploadId=' + partData.uploadId;
					console.log('url2', url2);
					let req = fnAWS().uploadPart({
						Bucket: 'copyrightupload',
						Key: globalAwss3Token.bucket + '/' + partData.key,
						UploadId: partData.uploadId,
						PartNumber: partData.number,
						Body: partData.body
					});
					req.build(() => {
						let headers = req.httpRequest.headers;
						console.log('headers', headers);
						delete headers['ETag'];
						delete headers['Content-Length'];
						delete headers['Host'];
						resolve({ url: url2, headers });
					});
				}
			);
		});
	},
	completeMultipartUpload(file, { uploadId, key, parts }) {
		return new Promise(resolve => {
			var params = {
				Bucket: globalAwss3Token.bucket,
				Key: globalAwss3Token.bucket + '/' + key,
				MultipartUpload: {
					Parts: parts
				},
				UploadId: uploadId
			};
			console.log('params', params);
			fnAWS().completeMultipartUpload(params, function(err, data) {
				if (err) {
					console.log(err, err.stack); // an error occurred
				} else {
					console.log('complete', data);
					resolve({ location: 'https://' + globalAwss3Token.endpoint + '/' + globalAwss3Token.bucket + '/' + key });
				}
			});
		});
	}
});
// uppy.use(StatusBar , {
//     hideAfterFinish: true,
//     showProgressDetails: false,
//     hideUploadButton: false,
//     hideRetryButton: false,
//     hidePauseResumeButton: false,
//     hideCancelButton: false,
// });
// uppy.use(GoogleDrive, { companionUrl: 'https://companion.uppy.io' })
// 	.use(Dropbox, {
// 		companionUrl: 'https://companion.uppy.io'
// 	})
// 	.use(Instagram, {
// 		companionUrl: 'https://companion.uppy.io'
// 	})
uppy.use(Webcam, {
	onBeforeSnapshot: () => Promise.resolve(),
	countdown: false,
	title: '开启摄像头',
	modes: ['video-audio', 'video-only', 'audio-only', 'picture'],
	mirror: true,
	facingMode: 'user'
});
//需要同源api进行抓取
// uppy.use(Url, {
//     // target: Dashboard,
//     companionUrl: 'https://companion.uppy.io/',
//     locale: {}
// });
uppy.on('complete', result => {
	const url = result.successful[0].uploadURL;
	console.log('result', result);
	alert('ok');
});
uppy.on('file-added', file => {
	Object.assign(file, { path: 'aulas' });
	console.log('file add...', file);
});
uppy.on('file-removed', file => {
	console.log('Removed file', file);
});
uppy.on('upload-progress', (file, progress) => {
	// file: { id, name, type, ... }
	// progress: { uploader, bytesUploaded, bytesTotal }
	console.log(file.id, progress.bytesUploaded, progress.bytesTotal);
});
uppy.on('upload-success', (file, response) => {
	console.log(file.name, response.uploadURL);
	// var img = new Image()
	// img.width = 300
	// img.alt = file.id
	// img.src = response.uploadURL
	// document.body.appendChild(img)
});
const mapStateToProps = state => {
	return {
		awss3Token: state.CopyrightBaseinfoReducers.awss3Token
	};
};
function CopyrightUppy(props) {
	let history = useHistory();
	const [open, setOpen] = useState(false);
	let dispatch = useDispatch();
	const mapState = useCallback(mapStateToProps, []);
	const { awss3Token = {} } = useMappedState(mapState);
	globalAwss3Token = awss3Token;
	// globalAwss3Token.secretAccessKey = "6CXU317GNL4QF113S1XBA76FOL6USI8CSZ8GCCB', 'SessionToken': 'a304UUrOoajA9xioI2hfYkikyWOCZJwGEcdygIckrMky/amqhSlPpp+qZwkeOJzqLAtX8wrN7KEF3adxymhBV17aLojJw7pPlJf3xotPT+NGTHQ/H2RqgltQ0+yoqNHzQSSsQF5znDP7bV+Ykeb86LB63I9FXlPWb900rFWCjxY3mSEDrfBCQ98HdcjxB188bRANziG2QZpigifUjrckxl+D2tmViL6+7pEa/EnemervIsDyi6FHM5BvwOJdEXffUyRRjKW84e79/aZdmYm8KX8CebL+MtTaj/a4omz8CLwg3Ui4GBtdo97RSRhbkUi5fHdbbYilyFnzBZXh+HeKx9t8iv8QFadcicv9Z56tkBZowKEJTItXKJodrZEjWN27LJ5y6fGE8d41BhfpsHe6XA==";
	// globalAwss3Token.accessKeyId = "MWjyBYnqs8gPU3SmpMH";
	console.log(awss3Token, 'awss3Token');
	return (
		<div className="copyright copyright-uppy">
			{/* <DragDrop
                uppy={uppy}
                locale={{
                    strings: {
                        // Text to show on the droppable area.
                        // `%{browse}` is replaced with a link that opens the system file selection dialog.
                        dropHereOr: '请上传文件 %{browse}',
                        // Used as the label for the link that opens the system file selection dialog.
                        browse: '1111111'
                    }
                }}
            /> */}
			<Button
				id="J_btn"
				className="primary-btn upload-btn"
				type="primary"
				size="small"
				inline
				onClick={() => {
					setOpen(true);
					dispatch(
						getUploadToken(null, data => {
							console.log('data....index', data);
						})
					);
				}}>
				上传
			</Button>
			{open ? (
				<DashboardModal
					inline={false}
					uppy={uppy}
					open={open}
					locale={{
						strings: {
							// Text to show on the droppable area.
							// `%{browse}` is replaced with a link that opens the system file selection dialog.
							// dropHereOr: '请上传文件 %{browse}',
							// Used as the label for the link that opens the system file selection dialog.
							// browse: '1111111'
							poweredBy: '版权图库上传',
							poweredByUppy: 'VPhoto',
							noDuplicates: '无法添加重复的文件“%{fileName}”，它已经存在'
						}
					}}
					plugins={['Webcam']}
					metaFields={[
						{ id: 'name', name: '文件名', placeholder: '文件名称' },
						{ id: 'caption', name: '描述', placeholder: '请填写图片描述' }
					]}
					trigger={'#J_btn'}
					closeModalOnClickOutside={true}
					onRequestClose={data => {
						console.log(data);
						setOpen(false);
					}}
					replaceTargetContent={true}
					showProgressDetails={true}
					note="上传图片、视频"
					saveFileCard={(meta, fileID) => {
						console.log('meta, fileID', meta, fileID);
					}}
				/>
			) : (
				''
			)}
		</div>
	);
}
export { CopyrightUppy };
